import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../../core/animations';
import * as _ from 'lodash';

import { environment } from '../../../../../../../../environments/environment';

/** Service file */
import { AuthService } from '../../../../authentication/auth.service';
import { ConfigurationService } from '../../../../configuration/configuration.service';
import { SideNavService } from '../sidenav.service';
import { EcommerceOrderService } from '../../../order/order.service';

/**Local component */
import { ToastComponent } from '../../../../common/toast.component';

/**Local files */
import { displayValues, apiCalls, spekwo, toastMsg, parentMenuItemsConfig } from '../../../../utils/index';
import { CommonOrdersService } from '../../commonOrders.service';
import * as moment from "moment";

@Component({
    selector: 'left-side',
    templateUrl: './left-sidenav.component.html',
    styleUrls: ['./left-sidenav.component.scss'],
    animations: fuseAnimations
})

export class OrdersleftSideComponent implements OnInit, OnDestroy {

    displayValues = displayValues;
    apiCalls = apiCalls;
    spekwoValues = spekwo;
    toastMsg = toastMsg;

    currentUserName: string;

    currentUserChangedSubscription: Subscription;
    filterOpMenu = [];
    filterBizMenu = [];
    filterBluereCrewtMenu = [];
    filterSolEstimatetMenu = [];


    constructor(
        private _router: Router,
        /**local service */
        private _authService: AuthService,
        /**local component */
        public toastComponent: ToastComponent,
        private configurationService: ConfigurationService,
        private sideNavService: SideNavService,
        public commonOrdersService: CommonOrdersService,
        private ecommerceOrderService: EcommerceOrderService

    ) {

    }

    ngOnInit() {

        this.currentUserChangedSubscription =
            this._authService.onCurrentUserChanged.subscribe(user => {
                this.currentUserName = user.firstName + ' ' + user.lastName;
            });

    }

    ngOnDestroy() {
        this.currentUserChangedSubscription.unsubscribe();
    }

    async ngAfterViewInit() {
        this.commonOrdersService.allMenuItems.subscribe((menuItems) => {

            this.filterOpMenu = menuItems.menuItemsList.filter((menuItem) => {
                return menuItem.parentMenuItem === parentMenuItemsConfig.operations;
            });

            this.filterSolEstimatetMenu = menuItems.menuItemsList.filter((menuItem) => {
                return menuItem.parentMenuItem === parentMenuItemsConfig.solutionEst;
            });

            this.filterBizMenu = menuItems.menuItemsList.filter((menuItem) => {
                return menuItem.parentMenuItem === parentMenuItemsConfig.bizDev;
            });

            this.filterBluereCrewtMenu = menuItems.menuItemsList.filter((menuItem) => {
                return menuItem.parentMenuItem === parentMenuItemsConfig.blueRecrewt;
            });
        });

    }

    operationChanges(opMenu) {
        console.log('opMenu',opMenu)
        if (opMenu.menuItems === "submit_bug" && opMenu.url) {
            window.open(opMenu.url, '_blank');
        } else if (opMenu.menuItems === "enter_crm" && opMenu.url) {
            window.open(opMenu.url, '_blank');
        }
        else if (opMenu.menuItems && opMenu.url) {
            this._router.navigate([opMenu.url]);
        } else {
            this.toastComponent.showToast(this.toastMsg.notEstablished);
        }
    }


    /**Sumbit bugs */
    submitBug() {
        window.open(this.apiCalls.bugTrack, '_blank');

    }

    /**Open calendar */
    openCalender() {
        this._router.navigate(['/apps/calendar']);
    }

    /** Link to excel */
    openKPI() {
        // Show the success message
        this._router.navigate(['/apps/e-commerce/kpi']);
        // this.toastComponent.showToast(this.toastMsg.notEstablished);
    }

    /** Team details */
    openTeam() {
        this._router.navigate(['/apps/users']);
    }

    /** Manage Reference details */
    openManageRef() {
        this._router.navigate(['/apps/e-commerce/manage-references']);
    }

    /** Manage Reference details */
    openSolutionDesc() {
        this._router.navigate(['/apps/e-commerce/solution-description']);
    }

    //open configuration screen
    openConfiguration() {
        this._router.navigate(['/apps/configurations']);
    }

    //open faq screen
    openFaq() {
        this._router.navigate(['/apps/faq']);
    }

    // open KPI Database screen
    openKPIDatabase() {
        this._router.navigate(['/apps/market-company-affiliate']);
    }

    //open permissons screen
    openPermission() {
        this._router.navigate(['/apps/permissions']);
    }

    /**Custom Order Creation */
    addNewOrder() {
        window.open(this.apiCalls.customOrder, '_blank');
    }

    /**List all archived orders */

    listArchivedOrders() {
        this._router.navigate(['/apps/e-commerce/archivedOrders']);
    }

    /**List all Customer Toggle Request */
    getCustomerToggleRequest() {
        this._router.navigate(['/apps/e-commerce/customerToggle']);
    }

    /**Pro details */
    openProInfo() {
        this._router.navigate(['/apps/e-commerce/userInfo']);
    }

    openPayment() {
        // Show the success message
        this.toastComponent.showToast(this.toastMsg.notEstablished);
    }

    /**Invite pro */

    invitePro() {
        // Show the success message
        this.toastComponent.showToast(this.toastMsg.notEstablished);
    }

    /**Reviews */
    openReviews() {
        this._router.navigate(['/apps/e-commerce/orders/review/all']);
    }

    // refresh orders
    async refreshOrdersWithLatest() {

        let orders = [];
        let offset = 0;
        await this.configurationService.getProductsList(null, null).then(async (producstRes) => {
            do {
                let payload = {
                    offset: offset,
                    first: 50
                };
                console.log("payload:", payload,)
                await this.sideNavService.GetAllOrders(payload).then(async (response: any) => {
                    let ordersList = response && response.data && response.data.length > 0 ? response.data : [];
                    if (ordersList.length > 0) {

                        var userId;
                        //Based on Userid get data
                        userId = window.localStorage.getItem('userUID');
                        await this.checkAndUpdateOrdersInDb(ordersList, userId, (producstRes && (producstRes['nodes'] && producstRes['nodes'].length > 0)) ? producstRes['nodes'] : []);
                        offset = offset + 50;
                    } else {
                        offset = null;
                        console.log(orders, 'final orders');
                    }
                })
            } while (offset != null)
        })

    }

    // check & update in DB
    async checkAndUpdateOrdersInDb(ordersList, userId, productsList) {
        for (let i = 0; i < ordersList.length; i++) {
            // setTimeout(async () => {
            let data = ordersList[i];
            let orderContent = ordersList[i] && ordersList[i]['orderContent'] ?
                JSON.parse(ordersList[i]['orderContent']) : "";

            let orderNodeId = ordersList[i] && ordersList[i]['id'] ? ordersList[i]['id'] : null;
            let orderId = ordersList[i] && ordersList[i].id ? ordersList[i].id : null;
            let statusId = null;

            //Due date calculation
            let dueDate;
            let product = orderContent && orderContent.line_items.length > 0 ? orderContent.line_items[0].sku : '';
            let paiAmount = orderContent && orderContent.total ? orderContent.total : 0.00;
            let productData = data && data.productByProductId ? data.productByProductId : {};
            let productAmount = productData && productData.productPrice ? productData.productPrice : 0.00;

            let couponData = data && data.couponByCouponId ? data.couponByCouponId : {};
            let discount = orderContent && orderContent.coupon_lines.length > 0 && orderContent.coupon_lines[0].discount ? orderContent.coupon_lines[0].discount : 0.00;

            if (discount === 0 || discount === 0.00) {
                discount = couponData && couponData.couponAmount ? couponData.couponAmount : 0.00;
            }
            if (!product) {
                product = productData && productData.sku ? productData.sku : "";
            }

            let lineMetaItems = orderContent && orderContent.line_items.length > 0 &&
                orderContent.line_items[0] && orderContent.line_items[0].meta_data && orderContent.line_items[0].meta_data.length > 0
                ? orderContent.line_items[0].meta_data : [];
            let deliveryTime = lineMetaItems.filter((data) => data.key === 'Delivery Time');
            if (product == this.spekwoValues.prouct1) {
                dueDate = this.calcDueDate(deliveryTime, orderContent.date_created);
            }
            else if (product == this.spekwoValues.prouct4 || product == this.spekwoValues.prouct5) {
                dueDate = this.calcDueDate(deliveryTime, orderContent.date_created);
            }

            if (product == this.spekwoValues.prouct5 && Number.parseFloat(paiAmount) === 39.00) {
                dueDate = this.calcDueDate(deliveryTime, orderContent.date_created);
            }

            if (!dueDate) {

                if (deliveryTime.length) {
                    dueDate = this.calcDueDate(deliveryTime, orderContent.date_created);
                } else {
                    dueDate = this.calcDueDate(deliveryTime, orderContent.date_created);
                }
            }
            //Due date calcualtion end 

            if (data && data.inspectionReportsSrcByOrderId && data.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId
            ) {
                var temp = data.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId;
                statusId = temp.statusId;
            }
            else if (data && data.orderStatusesByOrderId && data.orderStatusesByOrderId.nodes.length > 0) {
                statusId = data.orderStatusesByOrderId.nodes[0].statusByStatusId.statusId;
            }
            else if (data && data.inspectionReportsSrcByOrderId && data.inspectionReportsSrcByOrderId.reportReviewDetailsByInsReportId) {
                statusId = data.inspectionReportsSrcByOrderId.reportReviewDetailsByInsReportId.edges.length > 0
                    ? 3 : 1;
            }

            console.log(orderContent, 'orderContent 1')

            let tempHomeInspectionReport = orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                this.getMetaDataKeyBased(orderContent.meta_data, "homeInspection") : "";
            console.log(tempHomeInspectionReport, 'home bef')
            if (tempHomeInspectionReport) {
                tempHomeInspectionReport = tempHomeInspectionReport.toString().replace(environment.displayWebsite, environment.apiHostDisplay)
                console.log(tempHomeInspectionReport, 'home after')

                let commonIndex = this.getMetaDataKeyBasedIndex(orderContent.meta_data, "homeInspection");
                if (commonIndex != -1 && orderContent.meta_data[commonIndex]) {
                    orderContent.meta_data[commonIndex]['value'] = tempHomeInspectionReport;
                }
            }


            let tempDDRAReport = orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                this.getMetaDataKeyBased(orderContent.meta_data, "ddra") : "";
            console.log(tempDDRAReport, 'ddra bef')
            if (tempDDRAReport) {
                tempDDRAReport = tempDDRAReport.toString().replace(environment.displayWebsite, environment.apiHostDisplay)
                console.log(tempDDRAReport, 'ddra after')

                let commonIndex = this.getMetaDataKeyBasedIndex(orderContent.meta_data, "ddra");
                if (commonIndex != -1 && orderContent.meta_data[commonIndex]) {
                    orderContent.meta_data[commonIndex]['value'] = tempDDRAReport;
                }
            }

            let tempSupportReport = orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                this.getMetaDataKeyBased(orderContent.meta_data, "supportReport") : "";
            console.log(tempSupportReport, 'supportReport bef')
            if (tempSupportReport) {
                tempSupportReport = tempSupportReport.toString().replace(environment.displayWebsite, environment.apiHostDisplay)
                console.log(tempSupportReport, 'supportReport after')

                let commonIndex = this.getMetaDataKeyBasedIndex(orderContent.meta_data, "supportReport");
                if (commonIndex != -1 && orderContent.meta_data[commonIndex]) {
                    orderContent.meta_data[commonIndex]['value'] = tempSupportReport;
                }
            }

            let tempSupportingReport = orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                this.getMetaDataKeyBased(orderContent.meta_data, "supportingReport") : "";
            console.log(tempSupportingReport, 'supportingReport bef')
            if (tempSupportingReport) {
                tempSupportingReport = tempSupportingReport.toString().replace(environment.displayWebsite, environment.apiHostDisplay)
                console.log(tempSupportingReport, 'supportingReport after')

                let commonIndex = this.getMetaDataKeyBasedIndex(orderContent.meta_data, "supportingReport");
                if (commonIndex != -1 && orderContent.meta_data[commonIndex]) {
                    orderContent.meta_data[commonIndex]['value'] = tempSupportingReport;
                }
            }

            let tempUniqueReport = orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                this.getMetaDataKeyBased(orderContent.meta_data, "uniqueReport") : "";
            console.log(tempUniqueReport, 'uniqueReport bef')
            if (tempUniqueReport) {
                tempUniqueReport = tempUniqueReport.toString().replace(environment.displayWebsite, environment.apiHostDisplay)
                console.log(tempUniqueReport, 'uniqueReport after')

                let commonIndex = this.getMetaDataKeyBasedIndex(orderContent.meta_data, "uniqueReport");
                if (commonIndex != -1 && orderContent.meta_data[commonIndex]) {
                    orderContent.meta_data[commonIndex]['value'] = tempUniqueReport;
                }
            }

            let picUpload = orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                this.getMetaDataKeyBased(orderContent.meta_data, "picUpload") : "";
            console.log(picUpload, 'picUpload')

            console.log(typeof (picUpload), 'picUpload type')
            let checkPreList = picUpload && typeof (picUpload) == "string" ? (picUpload.includes(";") ? picUpload.split(";") : this.isJsonString(picUpload)) : null;
            console.log(typeof (checkPreList), 'checkPreList type')
            console.log(checkPreList, 'checkPreList')

            checkPreList = checkPreList && typeof (checkPreList) == "string" ? (checkPreList.includes(";") ? checkPreList.split(";") : this.isJsonString(checkPreList)) : checkPreList;
            console.log(checkPreList, 'checkPreList before')
            if (
                checkPreList &&
                checkPreList.length > 0
            ) {
                checkPreList.map((res) => {
                    if (res['image']) {
                        res['image'] = res['image'].toString().replace(environment.displayWebsite, environment.apiHostDisplay)
                    }
                });
                console.log(checkPreList, 'checkPreList after')

                let commonIndex = this.getMetaDataKeyBasedIndex(orderContent.meta_data, "picUpload");
                if (commonIndex != -1 && orderContent.meta_data[commonIndex]) {
                    orderContent.meta_data[commonIndex]['value'] = JSON.stringify(checkPreList);
                }
            }
            console.log(orderContent, '2')


            if (orderId) {
                let formattedPayload = {
                    "id": orderId,
                    "statusId": statusId ? statusId : 1,
                    "orderContent": JSON.stringify(orderContent),
                    "firstName": orderContent && orderContent.billing && orderContent.billing.first_name ?
                        orderContent.billing.first_name : "",
                    "lastName": orderContent && orderContent.billing && orderContent.billing.last_name ?
                        orderContent.billing.last_name : "",
                    "city": orderContent && orderContent.billing && orderContent.billing.city ?
                        orderContent.billing.city : "",
                    "state": orderContent && orderContent.billing && orderContent.billing.state ?
                        orderContent.billing.state : "",
                    "postcode": orderContent && orderContent.billing && orderContent.billing.postcode ?
                        orderContent.billing.postcode : "",
                    "address": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        (this.getMetaDataKeyBased(orderContent.meta_data, 'billing_myfield2') ?
                            this.getMetaDataKeyBased(orderContent.meta_data, 'billing_myfield2') :
                            this.getMetaDataKeyBased(orderContent.meta_data, '_billing_myfield2')) : "",
                    "homeinsurl": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        this.getMetaDataKeyBased(orderContent.meta_data, "homeInspection") : "",
                    "ddraurl": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        this.getMetaDataKeyBased(orderContent.meta_data, "ddra") : "",
                    "supportReportUrl": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        (this.getMetaDataKeyBased(orderContent.meta_data, "supportReport") ?
                            this.getMetaDataKeyBased(orderContent.meta_data, "supportReport") :
                            this.getMetaDataKeyBased(orderContent.meta_data, "supportingReport")) : "",
                    "uniqueReportUrl": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        this.getMetaDataKeyBased(orderContent.meta_data, "uniqueReport") : "",
                    "wdourl": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        this.getMetaDataKeyBased(orderContent.meta_data, "wdoReport") : "",
                    "structengurl": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        this.getMetaDataKeyBased(orderContent.meta_data, "structEngReport") : "",
                    "wellurl": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        this.getMetaDataKeyBased(orderContent.meta_data, "wellReport") : "",
                    "agentrole": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        (this.getMetaDataKeyBased(orderContent.meta_data, "_billing_myfield1") ?
                            this.getMetaDataKeyBased(orderContent.meta_data, "_billing_myfield1") :
                            this.getMetaDataKeyBased(orderContent.meta_data, "billing_myfield1")) : "",
                    "indrole": orderContent && orderContent.meta_data && orderContent.meta_data.length > 0 ?
                        (this.getMetaDataKeyBased(orderContent.meta_data, "_billing_myfield15") ?
                            this.getMetaDataKeyBased(orderContent.meta_data, "_billing_myfield15") :
                            this.getMetaDataKeyBased(orderContent.meta_data, "billing_myfield15")) : "",
                    "productId": orderContent && orderContent.line_items && orderContent.line_items.length > 0 && orderContent.line_items[0] &&
                        orderContent.line_items[0]['sku'] ?
                        this.getMatchedProduct(productsList, orderContent.line_items[0]['sku']) : null,
                    "editedAt": new Date(),
                    "editedBy": userId,
                    duedate: dueDate && dueDate !== "Invalid date" ? dueDate : null,
                }
                console.log("formattedPayload", formattedPayload);
                await this.sideNavService.EDIT_ORDER_NEW(orderId, formattedPayload).then((updateRes) => {
                    console.log('updateRes', i, ordersList.length, updateRes,)
                })
            }
            // }, i * 5000);
        }
    }

    getMetaDataKeyBased(checkArr, inputKey) {
        let filterData = _.find(checkArr, function (o) {
            return o.key.toString() == inputKey.toString();
        });
        return (filterData && filterData != undefined && filterData['value']) ? filterData['value'] : null;
    }

    getMetaDataKeyBasedIndex(checkArr, inputKey) {
        let filterIndex = _.findIndex(checkArr, function (o: any) {
            return o.key.toString() == inputKey.toString();
        });
        return filterIndex;
    }

    getMatchedProduct(checkArr, inputKey) {
        let filterData = _.find(checkArr, function (o) {
            return o.sku.toString() == inputKey.toString();
        });
        return (filterData && filterData != undefined && filterData['productId']) ? filterData['productId'] : null;
    }

    hoursBasedCost(productCost, discountAmount, paidAmount, createdDate) {
        let dueDate;
        if (productCost == discountAmount + paidAmount) {
            dueDate = moment(new Date(createdDate)).add(72, "hours").format("YYYY-MM-DD HH:mm:ss");
        } else if (productCost + 20 == discountAmount + paidAmount) {
            dueDate = moment(new Date(createdDate)).add(48, "hours").format("YYYY-MM-DD HH:mm:ss");
        } else if (productCost + 40 == discountAmount + paidAmount) {
            dueDate = moment(new Date(createdDate)).add(24, "hours").format("YYYY-MM-DD HH:mm:ss");
        }
        return dueDate;
    }

    calcDueDate(deliveryTime, createdDate) {
        let dueDate;

        if (deliveryTime.value.includes('72 hours')) {
            dueDate = moment(new Date(createdDate))
                .add(72, 'hours')
                .format('MM/DD/YYYY');
        }

        else if (deliveryTime.value.includes('48 hours')) {
            dueDate = moment(new Date(createdDate))
                .add(48, 'hours')
                .format('MM/DD/YYYY');
        }

        else if (deliveryTime.value.includes('24 hours')) {
            dueDate = moment(new Date(createdDate))
                .add(24, 'hours')
                .format('MM/DD/YYYY');
        }
        return dueDate;
    }

    hoursBasedCostByDeliveryTime(deiveryTime, createdDate) {
        let dueDate;
        if (deiveryTime === "72 hours") {
            dueDate = moment(new Date(createdDate)).add(72, "hours").format("YYYY-MM-DD HH:mm:ss");
        } else if (deiveryTime === "48 hours") {
            dueDate = moment(new Date(createdDate)).add(48, "hours").format("YYYY-MM-DD HH:mm:ss");
        } else if (deiveryTime === "24 hours") {
            dueDate = moment(new Date(createdDate)).add(24, "hours").format("YYYY-MM-DD HH:mm:ss");
        }
        return dueDate;
    }

    isJsonString(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return "";
        }
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/left-sidenav.component.ts